/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import {useDispatch} from 'react-redux'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import * as auth from '../redux/AuthRedux'
import {login} from '../redux/AuthCRUD'

const loginSchema = Yup.object().shape({
  email: Yup.string().email('Wrong email address').required('Email address is required'),
  password: Yup.string().required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [message, setMessage] = useState<string>('')
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      login(values.email, values.password)
        .then(({data}) => {
          if (data?.data?.hasOwnProperty('isTwoFactorVerified')) {
              navigate('/two-factor-auth/verify', {
                state: {
                  isTwoFactorVerified: data?.data?.isTwoFactorVerified,
                  qrCode: data?.data?.qrcode,
                  email: values?.email,
                },
              })
            return
          }
          if (data.status === 200) {
            setTimeout(() => {
              setLoading(false)
              dispatch(auth.actions.login(data.data.token))
            }, 500)
          } else {
            setMessage(data.message)
            setHasErrors(true)
            setSubmitting(false)
          }
        })
        .catch((error) => {
          console.log('error', error)
          setHasErrors(true)
          setLoading(false)
          setSubmitting(false)
          setMessage(error.response.data.message)
        })
    },
  })

  const [passwordShown, setPasswordShown] = useState(false)
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true)
    //setEyeSymbol(passwordShown ? "fa-eye" : "fa-eye-slash");
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Welcome Back!</h1>
      </div>
      {/* begin::Heading */}

      {/* begin::Title */}
      {hasErrors === true && message !== '' && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{message}</div>
        </div>
      )}

      {hasErrors === false && message !== '' && (
        <div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>{message}</div>
        </div>
      )}
      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email Address</label>
        <input
          placeholder='Email Address'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid'
            /* {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            } */
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
            {/* end::Label */}
          </div>
        </div>
        <div className='eyeWrapper'>
          <input
            type={passwordShown ? 'text' : 'password'}
            placeholder='Password'
            autoComplete='off'
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control form-control-lg form-control-solid'
              /* {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              } */
            )}
          />

          <i
            className={
              passwordShown
                ? 'fa fa-solid fa-eye cursor-pointer'
                : 'fa fa-solid fa-eye-slash cursor-pointer'
            }
            onClick={togglePasswordVisiblity}
          ></i>
        </div>

        <div className='d-flex justify-content-end position-relative'>
          <Link to='/forgot-password' className='link-primary fs-6 fw-bolder position-absolute'>
            Forgot Password ?
          </Link>
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Log In</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>
  )
}
